import { Component, OnInit } from '@angular/core';
import { LeaveService } from '../rest_services/msLeaveServices/leave.service';
import { UserService } from '../rest_services/user.service';
import { Form, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-absence',
  templateUrl: './absence.component.html',
  styleUrls: ['./absence.component.css']
})
export class AbsenceComponent implements OnInit {

  absence: any[] = [];
  absenceLoading:boolean=true;
  updateLeaveLoading:boolean=false;
  
  role!: string | null;
  selectedAbsence: any;
  updateLeaveForm!: FormGroup;
  constructor(
    private leaveService :LeaveService,
    private userService : UserService,
    private fb : FormBuilder
  ) { }
  fullname:any ='';
  ngOnInit(): void {
    if(localStorage.getItem("role")!=undefined) {
      this.role =localStorage.getItem("role");
      this.fullname =localStorage.getItem("fullname");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.role =sessionStorage.getItem("role");
      this.fullname =sessionStorage.getItem("fullname");
    }
    this.getLeaveList();

    this.updateLeaveForm = this.fb.group({
      reject_reason:[''],
      accept_reason:[''],
    })
  }

  getStatusText(status: number): string {
    switch (status) {
        case 1: return 'en attente'; // OPEN
        case 2: return 'en cours'; // IN_PROGRESS
        case 3: return 'accepté'; // ACCEPTED
        case 4: return 'rejeté'; // REJECTED
        case 5: return 'marqué comme retour'; // RETURNED
        case 6: return 'reporté'; // REPORTED
        case 7: return 'annulé'; // CANCELED
        default: return '----';
    }
}
editable(absence : any){
  if(this.role=='adm' && absence.fullname == this.fullname){
    return true;
  }if(this.role=='cmrc' || this.role=='asst'){
    return true;
  }
  return false;
}

  getLeaveList() {
    this.leaveService.getLeaveList();
    this.leaveService.leaveListSubject.subscribe(
      (data : any)=>{
        if(data.status =='200'){
          data.leaveEnvelops.sort((a: any, b: any) => {
            return new Date(b.sentAt).getTime() - new Date(a.sentAt).getTime();
        });
          this.absence = data.leaveEnvelops;
          if(this.role=='adm')this.fetchUserDataForAbsences();
          this.absenceLoading=false;        
          setTimeout(() => {
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "scrollCollapse": true,
              "aaSorting": [],
              "iDisplayLength": 10,
              // columnDefs: [ { type: 'date', 'targets': [2], "orderable": true } ],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
            });
          }, 400);
        }else{
          this.absence = [];     
          this.absenceLoading=false;   
          setTimeout(() => {
            (<any>$("#alter_pagination")).DataTable( {
              "destroy":true,
              "pagingType": "full_numbers",
              "scrollX": '400px',
              "scrollCollapse": true,
              "aaSorting": [],
              "iDisplayLength": 10,
              // columnDefs: [ { type: 'date', 'targets': [2], "orderable": true } ],
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                      type: 'line',
                      width: '60',
                      height: '20',
                      lineColor: '#1a73e9',
                      fillColor: '#c2d5ff',
                      spotColor: 'transparent',
                      minSpotColor: 'transparent',
                      maxSpotColor: 'transparent',
                      highlightSpotColor: 'transparent',
                      highlightLineColor: 'transparent',
                  });
              }
            });
          }, 400);
        }
      },
      (error :any) => {
        this.absence = [];     
        this.absenceLoading=false;   
        setTimeout(() => {
          (<any>$("#alter_pagination")).DataTable( {
            "destroy":true,
            "pagingType": "full_numbers",
            "scrollX": '400px',
            "scrollCollapse": true,
            "aaSorting": [],
            "iDisplayLength": 10,
            // columnDefs: [ { type: 'date', 'targets': [2], "orderable": true } ],
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                    type: 'line',
                    width: '60',
                    height: '20',
                    lineColor: '#1a73e9',
                    fillColor: '#c2d5ff',
                    spotColor: 'transparent',
                    minSpotColor: 'transparent',
                    maxSpotColor: 'transparent',
                    highlightSpotColor: 'transparent',
                    highlightLineColor: 'transparent',
                });
            }
          });
        }, 400);
      }
    )
  }

  fetchUserDataForAbsences() {
    this.absence.forEach((absence: any) => {
      const commercialId = absence.commercialId; // Assuming commercialId is the user UUID
      this.userService.getUserFilteredData(commercialId, ['fullName', 'avatar']).subscribe(
        (userData: any) => {
          if (userData) {
            absence.fullname = userData.connected_user.user_fullname;
            absence.avatar = userData.connected_user.user_avatar;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
    });
  }
  selectLeave(absence: any) {
    this.selectedAbsence = absence;
    this.updateLeaveForm.get('reject_reason')?.setValue('');
    this.updateLeaveForm.get('accept_reason')?.setValue('');
  }

  msg ='';
  update(leave: any, action: string) {
    $("html, body").animate({scrollTop:0});
    this.updateLeaveLoading= true;
    const decision_reason = action == 'reject'? this.updateLeaveForm.get('reject_reason')?.value: action == 'accept'? this.updateLeaveForm.get('accept_reason')?.value: '';
    let reqBody = {
      id: leave.id,
      decision_reason: decision_reason,
    }
    this.leaveService.updateLeave(reqBody, action);
    this.leaveService.updateLeaveSubject.subscribe(
      (data : any)=>{
        this.updateLeaveLoading= false;
        this.updateLeaveForm.reset();
        if(data.status == "200") {
          this.selectedAbsence.status = action == 'reject' ? 4 : action == 'accept' ? 3 : action == 'cancel' ? 7 : 1;
          this.msg = ` envoyée par ${leave.fullname} a été mise à jour avec succès.`;
          if(action == 'cancel')this.msg = `  a été annulé avec succès.`;
          (<any>$("#leave_updated")).show();
          setTimeout(() => {
            (<any>$("#leave_updated")).hide();          
          }, 5000);
        }else{
          this.msg = ' Une erreur est survenue';
          (<any>$("#leave_not_updated")).show();
          setTimeout(() => {
            (<any>$("#leave_not_updated")).hide();          
          }, 5000);
        }
        
      },
      (error :any) => {
        this.updateLeaveLoading= false;
        this.updateLeaveForm.reset();
        this.msg = ' Une erreur est survenue';
        (<any>$("#leave_not_updated")).show();
        setTimeout(() => {
          (<any>$("#leave_not_updated")).hide();          
        }, 5000);
      }
    )
  }
}
